var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { TabsCore } from '@core-front/tabs';
import TabsItem from '../tabs-item/tabs-item';
import { TabsContext } from './tabs-context';
import TabsNav from './tabs-nav';
const Tabs = (props) => {
    const { background, className, fullWidth, navigationType, pullTop, size = 'medium', align, theme } = props, rest = __rest(props, ["background", "className", "fullWidth", "navigationType", "pullTop", "size", "align", "theme"]);
    const tabsContextValue = {
        background,
        navigationType,
        align,
        size,
        theme,
    };
    const BEM = () => {
        const classArray = [`tabs--${size}`];
        if (background) {
            classArray.push('tabs--background-' + background);
        }
        if (navigationType) {
            classArray.push('tabs--' + navigationType);
        }
        if (fullWidth) {
            classArray.push('tabs--full-width');
        }
        if (pullTop) {
            classArray.push('tabs--pull-top');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(TabsContext.Provider, { value: tabsContextValue },
        React.createElement(TabsCore, Object.assign({ align: align, "data-theme": theme }, rest, { className: BEM(), components: {
                TabsItem,
                TabsNav,
            } }))));
};
export { Tabs as default };
